import { render } from "./serviceHistory.vue?vue&type=template&id=55a496fb&scoped=true&ts=true"
import script from "./serviceHistory.vue?vue&type=script&lang=ts"
export * from "./serviceHistory.vue?vue&type=script&lang=ts"

import "./serviceHistory.vue?vue&type=style&index=0&id=55a496fb&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a496fb"]])

export default __exports__